<template>
  <modal-key-container
    :title="$t('title')"
    @handleClose="handleClose"
  >
    <template #content>
      <emd-text
        size="regular"
        class="eu-mb_3"
        >{{ $t('description') }}
      </emd-text>

      <div class="emd-form-group">
        <label
          class="emd-label"
          for="secretKey"
        >
        </label>
        <input
          v-model="form.secretKey.masked_key"
          disabled
          readonly
          class="emd-input"
          type="text"
          id="secretKey"
          name="secretKey"
        />
      </div>

      <password-confirmation
        v-model="form.password"
        :has-error="authError"
        :placeholder="$t('form.password.placeholder')"
        label=""
      />

      <div class="emd-form-group">
        <jade-checkbox
          id="checkbox"
          :value.sync="form.checkbox"
          :label="$t('form.checkbox')"
        />
      </div>
    </template>

    <template #actions>
      <emd-button
        color="danger"
        data-testid="confirm-action"
        :disabled="computedDisabled"
        @click="handleClick"
      >
        {{ $t('form.button.delete') }}
      </emd-button>
    </template>
  </modal-key-container>
</template>

<script>
import { mapActions } from 'vuex'
import { EmdButton, EmdText } from 'emerald-vue/src/components'
import { required, minLength } from 'vuelidate/lib/validators'
import { JadeCheckbox } from '@jade'

import { isPreconditionFailed } from '@/enums/http-status.enum'

export default {
  name: 'ModalDeleteKeyContent',

  components: {
    EmdButton,
    EmdText,
    JadeCheckbox,
    ModalKeyContainer: () => import('./ModalKeyContainer.vue'),
    PasswordConfirmation: () =>
      import('@/components/project/molecules/PasswordConfirmation.vue')
  },

  props: {
    secretKey: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      authError: false,
      form: {
        password: '',
        checkbox: false,
        secretKey: this.secretKey
      }
    }
  },

  validations: {
    form: {
      secretKey: { required },
      checkbox: { required, checked: value => value },
      password: { required, minLength: minLength(4) }
    }
  },

  computed: {
    computedDisabled () {
      return this.$v.form.$invalid || this.authError || this.isLoading
    }
  },

  watch: {
    'form.password' (oldValue, newValue) {
      if (this.authError && oldValue !== newValue) {
        this.authError = !this.authError
      }
    }
  },

  methods: {
    ...mapActions(['DELETE_SECRET_KEY']),

    handleClose () {
      this.$emit('handleClose')
    },

    handleClick () {
      this.isLoading = true

      const params = {
        id: this.secretKey.id,
        body: {
          password: window.btoa(this.form.password)
        }
      }

      this.DELETE_SECRET_KEY(params)
        .then(() => {
          this.$emit('success')
          this.handleClose()
        })
        .catch(({ status }) => (this.authError = isPreconditionFailed(status)))
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Excluir chave",
      "description": "Tem certeza que deseja excluir esta chave?",
      "form.password.placeholder": "Informe sua senha",
      "form.checkbox": "Estou ciente que esta chave deixará de autenticar minhas aplicações à API do Pagar.me",
      "form.button.delete": "Excluir"
    },
    "en-US": {
      "title": "Excluir chave",
      "description": "Are you sure you want to delete this key?",
      "form.password.placeholder": "Digit password",
      "form.checkbox": "I am aware that this key will no longer authenticate my applications to the Pagar.me API",
      "form.button.delete": "Excluir"
    }
  }
</i18n>
